import React from 'react';
import { useHistory } from 'react-router-dom'
import clsx from 'clsx';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import Tooltip from '@material-ui/core/Tooltip';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';

import useStyles from './Style';
import { getUsername } from '@security/keycloak';

export function Navbar (props) {
    const classes = useStyles();
    let history = useHistory();

    const handleCloseAppClick = () => {
        history.push("/");
        sessionStorage.clear()
        props.handleLogout();
    }

    return (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
                [classes.appBarShift]: props.open,
            })}
        >
            <Toolbar>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid
                        item
                        container
                        direction="row"
                        xs={6}
                        lg={6}
                        justifyContent="flex-start"
                    >
                        { !props.open &&
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                onClick={props.click}
                                edge="start"
                                className={clsx(classes.menuButton, { [classes.hide]: props.open })}
                            >
                                <MenuIcon />
                            </IconButton>
                        }

                        <Typography variant="h6" noWrap style={{ display: 'flex', alignItems: 'center' }}>
                            {props.nameApp}
                        </Typography>

                        {props.handleLogoutProcess &&
                            <IconButton
                                color="inherit"
                                onClick={props.handleLogoutProcess}
                                label="Deixar Processo"
                                className={clsx(classes.menuButtonCloseProcess)}
                            >
                                <CloseIcon />
                            </IconButton>
                        }
                    </Grid>
                    <Grid
                        item
                        container
                        direction="row"
                        xs={5}
                        lg={5}
                        justifyContent="flex-end"
                    >
                        <Typography variant="h6" noWrap>
                          {getUsername()}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        container
                        direction="row"
                        xs={1}
                        lg={1}
                        justifyContent="flex-end"
                    >
                        <Tooltip title="Sair">
                            <IconButton
                                color="inherit"
                                aria-label="Sair"
                                edge="end"
                                onClick={handleCloseAppClick}
                            >
                                <ExitToAppIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    );
}

export default Navbar;
